module.exports = __webpack_public_path__ + "assets/img/enterIcon5.12153ad4.png";